export const sidebarActiveRoutes = {
  '/cambiar-contrasena': ['/cambiar-contrasena'],
  '/md-alumnos': ['/md-alumnos', '/add-alumno', '/update-alumno', '/iap'],
  '/md-axc': ['/md-axc', '/add-axc', '/update-axc', '/axc-inscribir'],
  '/ecur': ['/ecur'],
  '/md-carreras': ['/md-carreras', '/add-carrera', '/update-carrera'],
  '/md-mxc': ['/md-mxc', '/add-mxc', '/update-mxc'],
  '/md-crendir': ['/md-crendir', '/add-crendir', '/update-crendir'],
  '/md-ccursar': ['/md-ccursar', '/add-ccursar', '/update-ccursar'],
  '/md-cur': ['/md-cur', '/add-cur', '/update-cur', '/gen-cur'],
  '/md-ic': ['/md-ic', '/add-ic', '/update-ic', '/vic'],
  '/md-acur': ['/md-acur', '/acur/load', '/acur/watch'],
  '/md-hic': ['/md-hic', '/update-hic', '/accur'],
  '/md-mex': ['/md-mex', '/add-mex', '/update-mex', '/cme'],
  '/md-ie': ['/md-ie', '/add-ie', '/update-ie'],
  '/md-aex': ['/md-aex', '/aex/load', '/aex/watch', '/update-eae'],
  '/conactas': ['/conactas'],
  '/md-hex': ['/md-hex', '/update-hex'],
  '/md-anios': ['/md-anios', '/add-anio', '/update-anio'],
  '/md-pex': ['/md-pex', '/add-pex', '/update-pex'],
  '/md-pcr': ['/md-pcr', '/add-pcr', '/update-pcr'],
  '/md-aud': ['/md-aud'],
  '/md-ica': ['/md-ica', '/add-ica', '/update-ica'],
};

function normalizePathname(pathname) {
  return (pathname || '').split('?')[0];
}

function matchesPrefix(pathname, prefix) {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isSidebarItemActive(item, pathname) {
  if (!item || !item.href) {
    return false;
  }

  const path = normalizePathname(pathname);
  if (path === item.href) {
    return true;
  }

  const relatedPrefixes = sidebarActiveRoutes[item.href];
  if (!relatedPrefixes) {
    return false;
  }

  return relatedPrefixes.some((prefix) => matchesPrefix(path, prefix));
}

export function sectionHasActivePath(section, pathname, items) {
  const visibleItems = items || section.items || [];
  return visibleItems.some((item) => isSidebarItemActive(item, pathname));
}
